import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Button, useNotify, useRecordContext, type RaRecord } from "react-admin";

import { getRelayApprovalWhatsAppContext } from "./relay-approval-whatsapp-context";

export default function CopyRelayApprovalWhatsAppButton() {
  const notify = useNotify();
  const record = useRecordContext<RaRecord>();

  if (!record) {
    return null;
  }

  const { missingLink, missingContact, canBuildMessage, message } =
    getRelayApprovalWhatsAppContext(record);

  const handleCopy = async () => {
    if (missingLink) {
      notify("Configure a WhatsApp group link on the relay event first", { type: "warning" });
      return;
    }
    if (missingContact) {
      notify("ITS, name, and mobile are required to build the message", { type: "warning" });
      return;
    }

    try {
      await navigator.clipboard.writeText(message);
      notify("Approval message copied — paste into WhatsApp", { type: "success" });
    } catch {
      notify("Could not copy to clipboard", { type: "error" });
    }
  };

  return (
    <Button
      label="Copy WhatsApp message"
      onClick={() => {
        void handleCopy();
      }}
      disabled={!canBuildMessage}
    >
      <ContentCopyIcon />
    </Button>
  );
}
